import { atom } from 'recoil';

export const placeholderState = atom<string>({
  key: 'placeholder',
  default: '',
});
